module.exports = __webpack_public_path__ + "static/media/box-placeholder.f0fa3a36.png";